export * from './deepEqual';
export * from './getOpData';
export * from './pluck';
export * from './shallowCopy';
export * from './toArrayIndex';
export * from './toKeys';
export * from './softWrites';
export * from './log';
export * from './ops';
export * from './paths';
export * from './updateArrayIndexes';
export * from './updateArrayPath';
export * from './get';
export * from './getType';
